import { render, staticRenderFns } from "./ellipsis.vue?vue&type=template&id=5f06a16c"
var script = {}
import style0 from "./ellipsis.vue?vue&type=style&index=0&id=5f06a16c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports